<template>
    <v-row class="mt-12 mx-12">
        <v-col class="" cols="12">
            <v-card class="green lighten-4 pa-6 mx-auto elevation-12">
                <v-card-title class="justify-center">
                    <v-layout align-center>
                        <v-flex class="mb-3">
                            <div class="teal--text display-2 font-weight-bold text-center">서비스 소개</div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-layout justify-center>
                    <v-flex md10>
                        <v-card class="elevation-6">
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead class="">
                                        <tr>
                                            <th class="text-left teal--text" width="200px">구분</th>
                                            <th class="text-left teal--text">렌터카 이용전</th>
                                        </tr>
                                    </thead>
                                    <tbody class="">
                                        <tr>
                                            <td>계약기간</td>
                                            <td>2/3/4년</td>
                                        </tr>
                                        <tr>
                                            <td>총무부문</td>
                                            <td>만 26세 이상, 운전경력 1년 이상 (단, 10인승 이상 차량을 1종 보통이상 운전면허 소지자)</td>
                                        </tr>
                                        <tr>
                                            <td>대여 차종</td>
                                            <td>국내산 전 차종 (국산 및 수입차량, 전 차량 등급 및 옵션 선택 가능) – LPG 차량 선택 가능 차종 및 고객 맞춤형 (Basic, Standard1, Standard2, Standard3, Premium) 상품에 따라 선택 가능</td>
                                        </tr>
                                        <tr>
                                            <td>보험 보상한도</td>
                                            <td>대인 – 무한대 / 대물 – 2,000만원 자손 – 1,500만원 / 자차 – 자차손해면책제도 (과실로 인한 차량 수리시 사고 건당 면책금 30만원)</td>
                                        </tr>
                                        <tr>
                                            <td>보증관계</td>
                                            <td>보증증권 예치(상장사/외국회사/전문인/법인연혁에 따라 생략)<br />
                                                (서울보증보험 발행, 기타 금융권에서 발행하는 증권 무관)<br />
                                                <b>보증생략 대상</b><br />
                                                1. 상장사<br />
                                                2. 100% 외투기업<br />
                                                3. 전문인</td>
                                        </tr>
                                        <tr>
                                            <td>조기해약 위약금</td>
                                            <td>20%</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
export default {
  name: "NewcarServiceIntro",
  components: {
  },
  data: () => ({
  })
};
</script>
<style scoped></style>
